<template>
  <header :class="{scrolled: scrollPosition > 20}">
      <b-navbar toggleable="md" type="light">

        <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>

        <b-navbar-brand href="#">
          <h1>
            <router-link alt="Click2Giv" to="/"><img class="logo" :src=logo /></router-link>
          </h1>
        </b-navbar-brand>

        <div class="social-media">
          <a href="https://www.instagram.com/click2giv/" target="_blank"><font-awesome-icon class="icon" :icon="['fab', 'instagram']" size="lg" /></a>
          <a href="https://www.facebook.com/click2giv" target="_blank"><font-awesome-icon class="icon" :icon="['fab', 'facebook']" size="lg" /></a>
        </div>

        <b-collapse is-nav id="nav_collapse">

          <!-- Right aligned nav items -->
          <b-navbar-nav class="ml-auto">

            <b-nav-form>
              <form class="d-md-block form-inline ml-auto search">
                <font-awesome-icon class="icon" :icon="['fas', 'search']" size="lg" />
                <input v-on:keyup="searchProject()" class="form-control mr-sm-2" v-model="searchText" type="text" placeholder="Buscar Projeto" aria-label="Search" />
                <div class="searchloading"><font-awesome-icon v-if="searchLoading" class="icon fa-spin" :icon="['fas', 'spinner']"/></div>
                <a v-if="!searchLoading && isSearching" v-on:click.stop.prevent="clearSearch()" class="clearsearch"><font-awesome-icon class="icon" :icon="['fas', 'times-circle']" size="lg" /></a>
                <div class="result" v-if="resultProjects">
                  <ul>
                    <li v-for="p in resultProjects" :key="p.ProjectId">
                      <img v-if="p.Info.image" :src="p.Info.image" @click.stop.prevent="openProject(p.slug)"/>
                      <img v-else src="https://via.placeholder.com/100x100?text=Sem+Foto" @click.stop.prevent="openProject(p.slug)"/>
                      <a href="#" v-on:click.stop.prevent="openProject(p.slug)">{{p.Info.title}}</a>
                    </li>
                  </ul>
                </div>
              </form>
            </b-nav-form>

            <ul class="navbar-nav">
              <!-- <li class="nav-item active">
                <router-link class="nav-link" to="/aniversariodobem">Criar Convite</router-link>
              </li> -->
              <b-nav-item-dropdown left v-if="!isAuth">
                <template slot="button-content">
                  <a href="">Cadastre-se</a>
                </template>
                <b-dropdown-item href="/signup-ong">Cadastre-se como ONG</b-dropdown-item>
                <b-dropdown-item href="/signup">Cadastre-se como Usuário</b-dropdown-item>
              </b-nav-item-dropdown>
              <li class="nav-item active">
                <router-link class="nav-link" to="/projects">ONGs</router-link>
              </li>
              <b-nav-item-dropdown left>
                <template slot="button-content">
                  <a href="">Descontos do Bem</a>
                </template>
                <b-dropdown-item href="/descontosdobem?section=products">Produtos em Destaque</b-dropdown-item>
                <b-dropdown-item href="/descontosdobem?section=stores">Lojas com Ofertas</b-dropdown-item>
                <b-dropdown-item href="/descontosdobem?section=discounts">Cupons e Descontos</b-dropdown-item>
              </b-nav-item-dropdown>
              <li class="nav-item active">
                <router-link class="nav-link" to="/about">Sobre</router-link>
              </li>
              <li class="nav-item active" v-if="!isAuth">
                <router-link class="nav-link" to="/login">Entrar</router-link>
              </li>
              <b-nav-item-dropdown right v-if="isAuth">
                <template slot="button-content">
                  <a href="">Perfil <b-badge v-if="countUnreadNotifications > 0">{{countUnreadNotifications}}</b-badge></a>
                </template>
                <b-dropdown-item href="/dashboard">Dashboard</b-dropdown-item>
                <b-dropdown-item v-if="user && user.profile == 'ong'" href="/profile/my-projects">Meus Projetos</b-dropdown-item>
                <b-dropdown-item v-if="user && user.profile != 'ong'" href="/profile/my-donations">Minhas Doações</b-dropdown-item>
                <b-dropdown-item href="/profile">Meu Perfil</b-dropdown-item>
                <b-dropdown-item v-if="user && user.isPartner" href="/profile?tab=campaigns">Campanhas</b-dropdown-item>
                <div class="dropdown-divider"></div>
                <b-dropdown-item href="/notifications">Notificações <b-badge v-if="countUnreadNotifications > 0">{{countUnreadNotifications}}</b-badge></b-dropdown-item>
                <div class="dropdown-divider"></div>
                <a class="dropdown-item" href="#" v-on:click.stop.prevent="logout()">Sair</a>
              </b-nav-item-dropdown>
            </ul>

          </b-navbar-nav>

        </b-collapse>
      </b-navbar>
  </header>
</template>

<script>
import logo from '../../assets/images/logo.png';
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import {fasSearch, fasTimesCircle, fasSpinner} from '@fortawesome/fontawesome-free-solid'
import logoBlack from '../../assets/images/logo_black.png';
import { API } from '../../services/api'
import auth from '../../services/auth';

export default {
  name: 'Header',
  components: {
    FontAwesomeIcon
  },
  data () {
    return {
      logo: logoBlack,
      isAuth: false,
      notifications: null,
      countUnreadNotifications: 0,
      scrollPosition: null,
      searchText: null,
      isSearching: false,
      searchLoading: false,
      projects: null,
      resultProjects: null,
      user: null
    }
  },
  created(){
    if(auth.isAuth()){
      this.isAuth = true;
      this.getProfile();
      this.getNotifications();
    }
  },
  mounted(){
    this.updateScroll()
    window.addEventListener('scroll', this.updateScroll)
  },
  methods: {
    getProfile(){
      this.$http.get(API.Profile.profile, {headers: auth.getHeaders()}).then((result) => {
        this.user = result.body.user;
      }, (err) => {
        auth.logout();
        this.$router.push('/login');
      });
    },
    getNotifications(){
      if(this.isAuth){
        this.$http.get(API.Notifications.list, {headers: auth.getHeaders()}).then((result) => {
          this.notifications = result.body.notifications;
          var unreadNotifications = this.notifications.filter(n => {
            return n.wasReaded == false;
          })
          this.countUnreadNotifications = unreadNotifications.length;
        });
      }
    },
    logout(){
      auth.logout();
      this.$router.push('/login');
    },
    updateScroll(){
      this.scrollPosition = window.scrollY;
      if(this.scrollPosition > 20){
        this.logo = logo
      }else{
        this.logo = logoBlack
      }
    },
    searchProject(){
      if(this.searchText != null){
        if(this.searchText.length == 0){
          this.clearSearch()
        }else{
          this.isSearching = true;
          if(this.searchText.length > 2){
            if(this.projects && this.projects.length > 0){
              this.processSearch();
            }else{
              this.searchLoading = true;
              this.$http.get(API.Projects.projects).then((result) => {
                this.projects = result.body;
                this.processSearch();
              });
            }
          }
        }
      }
    },
    processSearch(){
      var string = (this.searchText) ? this.searchText.toLowerCase() : null;
      this.searchLoading = true;
      this.resultProjects = this.projects.filter((p) => {
        var title = p.Info.title.toLowerCase();
        return title.search(string) !== -1
      });
      if(this.resultProjects.length == 0){
        this.resultProjects = null;
      }
      this.searchLoading = false;
    },
    clearSearch(){
      this.resultProjects = null;
      this.searchText = null;
      this.isSearching = false;
      this.searchLoading = false;
    },
    openProject(slug){
      window.open('/project/' + slug, '_blank');
      // this.clearSearch();
    }
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
header{
  position: fixed;
  width: 100%;
  z-index: 1000;
  transition: background-color 0.3s ease;
  background-color: #fff;

  h1{
    margin-bottom: 0px;
    margin-top: 5px;
  }

  &.scrolled{
    background-color: #e1e1e1;
    box-shadow: 1px 0px 10px #ccc;
    min-height: 80px;

    .navbar-brand{
      height: 70px;
      line-height: 60px;
    }
  }

  .navbar-toggler{
    border: none;
  }

  .logo{
    width: 175px;
    @media screen and (max-width: 375px){
      width: 120px;
    }
  }

  .social-media{
    a{
      color: #00AE39;
      font-size: 26px;
    }
  }

  form{
    position: relative;

    @media screen and (max-width: 411px){
      width: 100%;
    }
      input{
        padding-left: 35px;
      }
      .icon{
        position: absolute;
        color: #ccc;
        top: 8px;
        left: 7px;
      }
      .clearsearch{
        position: absolute;
        color: #ccc;
        top: 1px;
        right: 42px;
        cursor: pointer;
      }
      .searchloading{
        position: absolute;
        top: 3px;
        right: 42px;
      }
      .result{
        position: absolute;
        background-color: #fff;
        border: thin solid #ccc;
        width: 100%;

        @media screen and(max-width: 411px){
          top: 40px;
          z-index: 999;
        }
        ul{
          list-style: none;
          padding: 0px;
          margin: 0px;
          li{
            color: #000;
            cursor: pointer;
            display: flex;
            height: auto;
            width: 100%;
            padding: 5px;
            overflow-x: hidden;
            text-overflow: ellipsis;
            img{
              cursor: pointer;
              height: 70px;
              width: 50%;
            }
            a{
              display: block;
              padding: 5px;
              width: 100%;
              height: 100%;
              text-decoration: none;
              color: #777;
              font-size: 12px;
            }
            &:hover{
              background-color: #777;
              a{
                color: #fff;
              }
            }
          }
        }
      }
    }

  .coupons-link{
    border: 2px solid #00AE39;
    font-size: 18px;
    padding: 10px;
    border-radius: 5px;
    color: #00AE39;
  }

  .navbar-brand{
    height: 80px;
    line-height: 65px;
  }

  .navbar-nav{

    .nav-link{

      text-decoration: none;
      a{
        text-decoration: none;
      }
      &:hover{
        a{
          color: #333;
        }
      }

    }
    .nav-item{
      a{
        font-family: RalewayRegular;
        color: #00AE39;
      }

      &.active{
        a{
          font-family: RalewayBold;
          color: #00AE39;
        }
      }

      .dropdown-toggle{
        a{
          font-family: RalewayBold;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/includes/Header.vue